import "prismjs";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-scss";
